export default "__VITE_ASSET__DA6Ab5xx__"